module.exports = __webpack_public_path__ + "static/img/FI.628a2d48.png";